export default "__VITE_ASSET__CRCbG0wM__$_?nuxt_component=async&nuxt_component_name=IUsdgEmojiList__"